<template>
    <v-container grid-list-xs pa-0 ma-0 class="full-width">
        <v-layout row wrap class="home-card">
            <v-layout
                row wrap
                v-if="$vuetify.breakpoint.xs"
            >
                <v-flex xs6>
                    <v-btn flat @click="showAuth">
                        <v-icon>mdi-login-variant</v-icon> {{ $t("authorization") }}
                    </v-btn>
                </v-flex>
                <v-flex xs6>
                    <v-btn flat @click="showRegistration">
                        <v-icon>mdi-account-plus</v-icon> {{ $t("registration") }}
                    </v-btn>
                </v-flex>
            </v-layout>

            <template v-if="$vuetify.breakpoint.lgAndUp">
                <v-carousel
                    height="calc(100vh - 84px)"
                    interval="5000"
                    hide-delimiters
                >
                    <v-carousel-item
                    v-for="(image,i) in ($i18n.locale == 'ru' ? startImagesRu : startImagesEn) "
                    :key="i"
                    :src="image.src"
                    transition="fade-transition"
                    ></v-carousel-item>
                </v-carousel>
            </template>

            <template v-else>
                <!-- Блок 1 -->
                <v-flex
                    xs12
                    md6
                    pa-5
                    white
                    :class="{'pa-5': $vuetify.breakpoint.smAndUp}"
                    class="sticky z-1"
                    v-if="$vuetify.breakpoint.mdAndUp"
                >
                    <v-card flat class="bg-transparent fill-height">
                        <v-layout row wrap align-center class="fill-height">
                            <v-img contain class="rounded" src="/img/start/ru/01.webp" width="100%" v-if="$i18n.locale == 'ru'"></v-img>
                            <v-img contain class="rounded" src="/img/start/en/01.webp" width="100%" v-else></v-img>
                        </v-layout>
                    </v-card>
                </v-flex>
                <v-flex
                    xs12
                    md6
                    white
                    :class="{'sticky': $vuetify.breakpoint.mdAndUp, 'pa-5': $vuetify.breakpoint.smAndUp, 'half': $vuetify.breakpoint.smAndDown}"
                    class="z-1"
                >
                    <v-layout row wrap align-center fill-height>
                        <v-card flat class="bg-transparent">
                            <v-card-title>
                                <v-flex :class="{'center': $vuetify.breakpoint.smAndDown}">
                                    <span
                                        class="font-teal_darken-3"
                                        :class="{'display-2': $vuetify.breakpoint.lgAndUp, 'display-1': $vuetify.breakpoint.mdAndDown}"
                                        v-if="$i18n.locale == 'ru'"
                                    >В помощь плановику лесопильного производства</span>
                                    <span
                                        class="font-teal_darken-3"
                                        :class="{'display-2': $vuetify.breakpoint.lgAndUp, 'display-1': $vuetify.breakpoint.mdAndDown}"
                                        v-else
                                    >To assist the sawmill planner</span>
                                </v-flex>
                            </v-card-title>
                            <v-card-text>
                                <v-flex :class="{'center': $vuetify.breakpoint.smAndDown}">
                                    <span :class="{'headline': $vuetify.breakpoint.mdAndUp, 'title': $vuetify.breakpoint.smAndDown}" v-if="$i18n.locale == 'ru'">
                                        MillLab - инструмент оптимизации лесопиления, предназначенный для достижения максимального полезного выхода продукции.
                                    </span>
                                    <span :class="{'headline': $vuetify.breakpoint.mdAndUp, 'title': $vuetify.breakpoint.smAndDown}" v-else>
                                        MillLab is a sawmill optimization tool designed to maximize the yield.
                                    </span>
                                </v-flex>
                            </v-card-text>
                        </v-card>
                    </v-layout>
                </v-flex>
                <v-flex
                    xs12
                    md6
                    white
                    class="half z-1 pa-2"
                    v-if="$vuetify.breakpoint.smAndDown"
                >
                    <v-card flat class="bg-transparent fill-height">
                        <v-layout row wrap align-center class="fill-height">
                            <v-img contain class="rounded" src="/img/start/ru/01.webp" width="100%" v-if="$i18n.locale == 'ru'"></v-img>
                            <v-img contain class="rounded" src="/img/start/en/01.webp" width="100%" v-else></v-img>
                        </v-layout>
                    </v-card>
                </v-flex>

                <!-- Блок 2 -->
                <v-flex
                    xs12
                    md6
                    blue-grey lighten-5
                    :class="{'sticky': $vuetify.breakpoint.mdAndUp, 'pa-5': $vuetify.breakpoint.smAndUp, 'half': $vuetify.breakpoint.smAndDown}"
                    class="z-2"
                >
                    <v-layout row wrap align-center fill-height>
                        <v-card flat class="bg-transparent">
                            <v-card-title>
                                <v-flex :class="{'center': $vuetify.breakpoint.smAndDown}">
                                    <span
                                        class="font-teal_darken-3"
                                        :class="{'display-2': $vuetify.breakpoint.lgAndUp, 'display-1': $vuetify.breakpoint.mdAndDown}"
                                        v-if="$i18n.locale == 'ru'"
                                    >Расчет оптимальных поставов под параметры вашей лесопильной линии</span>
                                    <span
                                        class="font-teal_darken-3"
                                        :class="{'display-2': $vuetify.breakpoint.lgAndUp, 'display-1': $vuetify.breakpoint.mdAndDown}"
                                        v-else
                                    >Optimal sawing patterns calculation according to your sawmill line parameters</span>
                                </v-flex>
                            </v-card-title>
                            <v-card-text>
                                <v-flex :class="{'center': $vuetify.breakpoint.smAndDown}">
                                    <span
                                        class="font-grey_darken-3"
                                        :class="{'headline': $vuetify.breakpoint.mdAndUp, 'title': $vuetify.breakpoint.smAndDown}"
                                        v-if="$i18n.locale == 'ru'"
                                    >
                                        При расчете постава учитываются размеры бревна и кривизна, требуемые размеры пиломатериалов и их стоимость, а также характеристики
                                        лесопильного оборудования.
                                    </span>
                                    <span
                                        class="font-grey_darken-3"
                                        :class="{'headline': $vuetify.breakpoint.mdAndUp, 'title': $vuetify.breakpoint.smAndDown}"
                                        v-else
                                    >
                                        When calculating the sawing pattern, the program takes into account log dimensions and its curvature,
                                        required lumber dimensions and their cost as well as sawmill equipment characteristics.
                                    </span>
                                </v-flex>
                            </v-card-text>
                        </v-card>
                    </v-layout>
                </v-flex>
                <v-flex
                    xs12
                    md6
                    blue-grey lighten-5
                    :class="{'sticky pa-5': $vuetify.breakpoint.mdAndUp, 'half pa-2': $vuetify.breakpoint.smAndDown}"
                    class="z-2"
                >
                    <v-card flat class="bg-transparent fill-height">
                        <v-layout row wrap align-center class="fill-height">
                            <v-img contain class="rounded" src="/img/start/ru/02.webp" width="100%" v-if="$i18n.locale == 'ru'"></v-img>
                            <v-img contain class="rounded" src="/img/start/en/02.webp" width="100%" v-else></v-img>
                        </v-layout>
                    </v-card>
                </v-flex>

                <!-- Блок 3 -->
                <v-flex
                    xs12
                    md6
                    green lighten-4
                    class="sticky z-3"
                    :class="{'pa-5': $vuetify.breakpoint.smAndUp}"
                    v-if="$vuetify.breakpoint.mdAndUp"
                >
                    <v-card flat class="bg-transparent fill-height">
                        <v-layout row wrap align-center class="fill-height">
                            <v-img contain class="rounded" src="/img/start/ru/03.webp" width="100%" v-if="$i18n.locale == 'ru'"></v-img>
                            <v-img contain class="rounded" src="/img/start/en/03.webp" width="100%" v-else></v-img>
                        </v-layout>
                    </v-card>
                </v-flex>
                <v-flex
                    xs12
                    md6
                    green lighten-4
                    :class="{'sticky': $vuetify.breakpoint.mdAndUp, 'pa-5': $vuetify.breakpoint.smAndUp, 'half': $vuetify.breakpoint.smAndDown}"
                    class="z-3"
                >
                    <v-layout row wrap align-center fill-height>
                        <v-card flat class="bg-transparent">
                            <v-card-title>
                                <v-flex :class="{'center': $vuetify.breakpoint.smAndDown}">
                                    <span
                                        class="font-teal_darken-3"
                                        :class="{'display-2': $vuetify.breakpoint.lgAndUp, 'display-1': $vuetify.breakpoint.mdAndDown}"
                                        v-if="$i18n.locale == 'ru'"
                                    >Поиск оптимальных параметров пиловочника</span>
                                    <span
                                        class="font-teal_darken-3"
                                        :class="{'display-2': $vuetify.breakpoint.lgAndUp, 'display-1': $vuetify.breakpoint.mdAndDown}"
                                        v-else
                                    >Search for optimal raw material dimensions</span>
                                </v-flex>
                            </v-card-title>
                            <v-card-text>
                                <v-flex :class="{'center': $vuetify.breakpoint.smAndDown}">
                                    <span
                                        class="font-grey_darken-3"
                                        :class="{'headline': $vuetify.breakpoint.mdAndUp, 'title': $vuetify.breakpoint.smAndDown}"
                                        v-if="$i18n.locale == 'ru'"
                                    >
                                        Выберите интересующий вас постав, задайте параметры бревен, и система рассчитает наилучший диаметр и диапазон оптимальных диаметров для эффективного пиления.
                                    </span>
                                    <span
                                        class="font-grey_darken-3"
                                        :class="{'headline': $vuetify.breakpoint.mdAndUp, 'title': $vuetify.breakpoint.smAndDown}"
                                        v-else
                                    >
                                        Select the required sawing pattern, set log parameters and our system will calculate the best diameter and optimal diameters range for efficient sawing.
                                    </span>
                                </v-flex>
                            </v-card-text>
                        </v-card>
                    </v-layout>
                </v-flex>
                <v-flex
                    xs12
                    md6
                    green lighten-4
                    class="half z-3 pa-2"
                    v-if="$vuetify.breakpoint.smAndDown"
                >
                    <v-card flat class="bg-transparent fill-height">
                        <v-layout row wrap align-center class="fill-height">
                            <v-img contain class="rounded" src="/img/start/ru/03.webp" width="100%" v-if="$i18n.locale == 'ru'"></v-img>
                            <v-img contain class="rounded" src="/img/start/en/03.webp" width="100%" v-else></v-img>
                        </v-layout>
                    </v-card>
                </v-flex>

                <!-- Блок 4 -->
                <v-flex
                    xs12
                    md6
                    light-blue lighten-5
                    :class="{'sticky': $vuetify.breakpoint.mdAndUp, 'pa-5': $vuetify.breakpoint.smAndUp, 'half': $vuetify.breakpoint.smAndDown}"
                    class="z-4"
                >
                    <v-layout row wrap align-center fill-height>
                        <v-card flat class="bg-transparent">
                            <v-card-title>
                                <v-flex :class="{'center': $vuetify.breakpoint.smAndDown}">
                                    <span
                                        class="font-teal_darken-3"
                                        :class="{'display-2': $vuetify.breakpoint.lgAndUp, 'display-1': $vuetify.breakpoint.mdAndDown}"
                                        v-if="$i18n.locale == 'ru'"
                                    >Улучшение показателей</span>
                                    <span
                                        class="font-teal_darken-3"
                                        :class="{'display-2': $vuetify.breakpoint.lgAndUp, 'display-1': $vuetify.breakpoint.mdAndDown}"
                                        v-else
                                    >Productivity growth</span>
                                </v-flex>
                            </v-card-title>
                            <v-card-text>
                                <v-flex :class="{'center': $vuetify.breakpoint.smAndDown}">
                                    <span
                                        class="font-grey_darken-3"
                                        :class="{'headline': $vuetify.breakpoint.mdAndUp, 'title': $vuetify.breakpoint.smAndDown}"
                                        v-if="$i18n.locale == 'ru'"
                                    >
                                        Мы поможем вам обеспечить максимальный выход или максимальную стоимость продукции, а также рассчитать величину обзольности
                                        досок, объем и стоимость готовой продукции.
                                    </span>
                                    <span
                                        class="font-grey_darken-3"
                                        :class="{'headline': $vuetify.breakpoint.mdAndUp, 'title': $vuetify.breakpoint.smAndDown}"
                                        v-else
                                    >
                                        We will help you to get the maximum output or maximum cost of your product as well as to calculate the board wane, the finished product volume and cost.
                                    </span>
                                </v-flex>
                            </v-card-text>
                        </v-card>
                    </v-layout>
                </v-flex>
                <v-flex
                    xs12
                    md6
                    light-blue lighten-5
                    :class="{'sticky pa-5': $vuetify.breakpoint.mdAndUp, 'half pa-2': $vuetify.breakpoint.smAndDown}"
                    class="z-4"
                >
                    <v-card flat class="bg-transparent fill-height">
                        <v-layout row wrap align-center class="fill-height">
                            <v-img contain class="rounded" src="/img/start/ru/04.webp" width="100%" v-if="$i18n.locale == 'ru'"></v-img>
                            <v-img contain class="rounded" src="/img/start/en/04.webp" width="100%" v-else></v-img>
                        </v-layout>
                    </v-card>
                </v-flex>

                <!-- Блок 5 -->
                <v-flex
                    xs12
                    md6
                    cyan lighten-4
                    class="sticky pa-5 z-5"
                    v-if="$vuetify.breakpoint.mdAndUp"
                >
                    <v-card flat class="bg-transparent fill-height">
                        <v-layout row wrap align-center class="fill-height">
                            <v-img contain class="rounded" src="/img/start/ru/06.webp" width="100%" v-if="$i18n.locale == 'ru'"></v-img>
                            <v-img contain class="rounded" src="/img/start/en/06.webp" width="100%" v-else></v-img>
                        </v-layout>
                    </v-card>
                </v-flex>
                <v-flex
                    xs12
                    md6
                    cyan lighten-4
                    :class="{'sticky': $vuetify.breakpoint.mdAndUp, 'pa-5': $vuetify.breakpoint.smAndUp, 'half': $vuetify.breakpoint.smAndDown}"
                    class="z-5"
                >
                    <v-layout row wrap align-center fill-height>
                        <v-card flat class="bg-transparent">
                            <v-card-title>
                                <v-flex :class="{'center': $vuetify.breakpoint.smAndDown}">
                                    <span
                                        class="font-teal_darken-3"
                                        :class="{'display-2': $vuetify.breakpoint.lgAndUp, 'display-1': $vuetify.breakpoint.mdAndDown}"
                                        v-if="$i18n.locale == 'ru'"
                                    >От небольших предприятий до крупных холдингов</span>
                                    <span
                                        class="font-teal_darken-3"
                                        :class="{'display-2': $vuetify.breakpoint.lgAndUp, 'display-1': $vuetify.breakpoint.mdAndDown}"
                                        v-else
                                    >From small enterprises to large holding companies</span>
                                </v-flex>
                            </v-card-title>
                            <v-card-text>
                                <v-flex :class="{'center': $vuetify.breakpoint.smAndDown}">
                                    <span
                                        class="font-grey_darken-3"
                                        :class="{'headline': $vuetify.breakpoint.mdAndUp, 'title': $vuetify.breakpoint.smAndDown}"
                                        v-if="$i18n.locale == 'ru'"
                                    >
                                        Сервис позволяет выполнять расчеты как одному пользователю, так и организовать комфортную работу
                                        нескольким сотрудникам при помощи гибкой системы прав и совместного доступа.
                                    </span>
                                    <span
                                        class="font-grey_darken-3"
                                        :class="{'headline': $vuetify.breakpoint.mdAndUp, 'title': $vuetify.breakpoint.smAndDown}"
                                        v-else
                                    >
                                        Our service allows you both to perform calculations as one user and to organize comfortable work for several employees using a flexible system of rights and shared access.
                                    </span>
                                </v-flex>
                            </v-card-text>
                        </v-card>
                    </v-layout>
                </v-flex>
                <v-flex
                    xs12
                    md6
                    cyan lighten-4
                    class="half z-5 pa-2"
                    v-if="$vuetify.breakpoint.smAndDown"
                >
                    <v-card flat class="bg-transparent fill-height">
                        <v-layout row wrap align-center class="fill-height">
                            <v-img contain class="rounded" src="/img/start/ru/06.webp" width="100%" v-if="$i18n.locale == 'ru'"></v-img>
                            <v-img contain class="rounded" src="/img/start/en/06.webp" width="100%" v-else></v-img>
                        </v-layout>
                    </v-card>
                </v-flex>

                <!-- Блок 6 -->
                <v-flex
                    xs12
                    md6
                    teal lighten-4
                    :class="{'sticky': $vuetify.breakpoint.mdAndUp, 'pa-5': $vuetify.breakpoint.smAndUp, 'half': $vuetify.breakpoint.smAndDown}"
                    class="z-6"
                >
                    <v-layout row wrap align-center fill-height>
                        <v-card flat class="bg-transparent">
                            <v-card-title>
                                <v-flex :class="{'center': $vuetify.breakpoint.smAndDown}">
                                    <span
                                        class="font-teal_darken-3"
                                        :class="{'display-2': $vuetify.breakpoint.lgAndUp, 'display-1': $vuetify.breakpoint.mdAndDown}"
                                        v-if="$i18n.locale == 'ru'"
                                    >Удобство использования</span>
                                    <span
                                        class="font-teal_darken-3"
                                        :class="{'display-2': $vuetify.breakpoint.lgAndUp, 'display-1': $vuetify.breakpoint.mdAndDown}"
                                        v-else
                                    >Usability</span>
                                </v-flex>
                            </v-card-title>
                            <v-card-text>
                                <v-flex :class="{'center': $vuetify.breakpoint.smAndDown}">
                                    <span
                                        class="font-grey_darken-3"
                                        :class="{'headline': $vuetify.breakpoint.mdAndUp, 'title': $vuetify.breakpoint.smAndDown}"
                                        v-if="$i18n.locale == 'ru'"
                                    >
                                        Интуитивно понятный интерфейс значительно облегчает освоение и последующее использование программы.
                                    </span>
                                    <span
                                        class="font-grey_darken-3"
                                        :class="{'headline': $vuetify.breakpoint.mdAndUp, 'title': $vuetify.breakpoint.smAndDown}"
                                        v-else
                                    >
                                        Intuitive interface makes it much easier to explore and use the program.
                                    </span>
                                </v-flex>
                            </v-card-text>
                        </v-card>
                    </v-layout>
                </v-flex>
                <v-flex
                    xs12
                    md6
                    teal lighten-4
                    :class="{'half pa-2': $vuetify.breakpoint.smAndDown, 'sticky pa-5': $vuetify.breakpoint.mdAndUp}"
                    class="z-6"
                >
                    <v-card flat class="bg-transparent fill-height">
                        <v-layout row wrap align-center class="fill-height">
                            <v-img contain class="rounded" src="/img/start/ru/05.webp" width="100%" v-if="$i18n.locale == 'ru'"></v-img>
                            <v-img contain class="rounded" src="/img/start/en/05.webp" width="100%" v-else></v-img>
                        </v-layout>
                    </v-card>
                </v-flex>

                <!-- Блок 7 -->
                <v-flex
                    xs12
                    md6
                    blue lighten-4
                    class="sticky pa-5 z-7"
                    v-if="$vuetify.breakpoint.mdAndUp"
                >
                    <v-card flat class="bg-transparent fill-height">
                        <v-layout row wrap align-center class="fill-height">
                            <v-img contain class="rounded" src="/img/start/07.webp" width="100%"></v-img>
                        </v-layout>
                    </v-card>
                </v-flex>
                <v-flex
                    xs12
                    md6
                    blue lighten-4
                    :class="{'sticky': $vuetify.breakpoint.mdAndUp, 'pa-5': $vuetify.breakpoint.smAndUp, 'half': $vuetify.breakpoint.smAndDown}"
                    class="z-7"
                >
                    <v-layout row wrap align-center fill-height>
                        <v-card flat class="bg-transparent">
                            <v-card-title>
                                <v-flex :class="{'center': $vuetify.breakpoint.smAndDown}">
                                    <span
                                        class="font-teal_darken-3"
                                        :class="{'display-2': $vuetify.breakpoint.lgAndUp, 'display-1': $vuetify.breakpoint.mdAndDown}"
                                        v-if="$i18n.locale == 'ru'"
                                    >На острие прогресса</span>
                                    <span
                                        class="font-teal_darken-3"
                                        :class="{'display-2': $vuetify.breakpoint.lgAndUp, 'display-1': $vuetify.breakpoint.mdAndDown}"
                                        v-else
                                    >At the cutting edge of progress</span>
                                </v-flex>
                            </v-card-title>
                            <v-card-text>
                                <v-flex :class="{'center': $vuetify.breakpoint.smAndDown}">
                                    <span
                                        class="font-grey_darken-3"
                                        :class="{'headline': $vuetify.breakpoint.mdAndUp, 'title': $vuetify.breakpoint.smAndDown}"
                                        v-if="$i18n.locale == 'ru'"
                                    >
                                        Мы постоянно работаем над улучшением программного обеспечения, подписка позволяет вам пользоваться новыми функциями
                                        без необходимости покупать и устанавливать новую версию ПО.
                                    </span>
                                    <span
                                        class="font-grey_darken-3"
                                        :class="{'headline': $vuetify.breakpoint.mdAndUp, 'title': $vuetify.breakpoint.smAndDown}"
                                        v-else
                                    >
                                        We are constantly working on improving the software, a subscription allows you to take advantage of new features without having to buy and install a new software version.
                                    </span>
                                </v-flex>
                            </v-card-text>
                        </v-card>
                    </v-layout>
                </v-flex>
                <v-flex
                    xs12
                    md6
                    blue lighten-4
                    class="half z-7 pa-2"
                    v-if="$vuetify.breakpoint.smAndDown"
                >
                    <v-card flat class="bg-transparent fill-height">
                        <v-layout row wrap align-center class="fill-height">
                            <v-img contain class="rounded" src="/img/start/07.webp" width="100%"></v-img>
                        </v-layout>
                    </v-card>
                </v-flex>

                <!-- Блок 8 -->
                <v-flex
                    xs12
                    md6
                    amber lighten-5
                    :class="{'sticky': $vuetify.breakpoint.mdAndUp, 'pa-5': $vuetify.breakpoint.smAndUp, 'half': $vuetify.breakpoint.smAndDown}"
                    class="z-8"
                >
                    <v-layout row wrap align-center fill-height>
                        <v-card flat class="bg-transparent">
                            <v-card-title>
                                <v-flex :class="{'center': $vuetify.breakpoint.smAndDown}">
                                    <span
                                        class="font-teal_darken-3"
                                        :class="{'display-2': $vuetify.breakpoint.lgAndUp, 'display-1': $vuetify.breakpoint.mdAndDown}"
                                        v-if="$i18n.locale == 'ru'"
                                    >Доступность</span>
                                    <span
                                        class="font-teal_darken-3"
                                        :class="{'display-2': $vuetify.breakpoint.lgAndUp, 'display-1': $vuetify.breakpoint.mdAndDown}"
                                        v-else
                                    >Accessibility</span>
                                </v-flex>
                            </v-card-title>
                            <v-card-text>
                                <v-flex :class="{'center': $vuetify.breakpoint.smAndDown}">
                                    <span
                                        class="font-grey_darken-3"
                                        :class="{'headline': $vuetify.breakpoint.mdAndUp, 'title': $vuetify.breakpoint.smAndDown}"
                                        v-if="$i18n.locale == 'ru'"
                                    >
                                        Все данные хранятся на сервере и доступны вашим сотрудникам в любой точке мира в режиме 24/7.
                                    </span>
                                    <span
                                        class="font-grey_darken-3"
                                        :class="{'headline': $vuetify.breakpoint.mdAndUp, 'title': $vuetify.breakpoint.smAndDown}"
                                        v-else
                                    >
                                        All data is stored on the server and is available to your employees from anywhere in the world 24/7.
                                    </span>
                                </v-flex>
                            </v-card-text>
                        </v-card>
                    </v-layout>
                </v-flex>
                <v-flex
                    xs12
                    md6
                    amber lighten-5
                    :class="{'sticky pa-5': $vuetify.breakpoint.mdAndUp, 'half pa-2': $vuetify.breakpoint.smAndDown}"
                    class="z-8"
                >
                    <v-card flat class="bg-transparent fill-height">
                        <v-layout row wrap align-center class="fill-height">
                            <v-img contain class="rounded" src="/img/start/08.webp" width="100%"></v-img>
                        </v-layout>
                    </v-card>
                </v-flex>

                <!-- Блок 9 -->
                <v-flex
                    xs12
                    md6
                    brown lighten-5
                    class="sticky pa-5 z-8"
                    v-if="$vuetify.breakpoint.mdAndUp"
                >
                    <v-card flat class="bg-transparent fill-height">
                        <v-layout row wrap align-center class="fill-height">
                            <v-img contain class="rounded" src="/img/start/09.webp" width="100%"></v-img>
                        </v-layout>
                    </v-card>
                </v-flex>
                <v-flex
                    xs12
                    md6
                    brown lighten-5
                    :class="{'sticky': $vuetify.breakpoint.mdAndUp, 'pa-5': $vuetify.breakpoint.smAndUp, 'half': $vuetify.breakpoint.smAndDown}"
                    class="z-8"
                >
                    <v-layout row wrap align-center fill-height>
                        <v-card flat class="bg-transparent">
                            <v-card-title>
                                <v-flex :class="{'center': $vuetify.breakpoint.smAndDown}">
                                    <span
                                        class="font-teal_darken-3"
                                        :class="{'display-2': $vuetify.breakpoint.lgAndUp, 'display-1': $vuetify.breakpoint.mdAndDown}"
                                        v-if="$i18n.locale == 'ru'"
                                    >Надежность</span>
                                    <span
                                        class="font-teal_darken-3"
                                        :class="{'display-2': $vuetify.breakpoint.lgAndUp, 'display-1': $vuetify.breakpoint.mdAndDown}"
                                        v-else
                                    >Reliability</span>
                                </v-flex>
                            </v-card-title>
                            <v-card-text>
                                <v-flex :class="{'center': $vuetify.breakpoint.smAndDown}">
                                    <span
                                        class="font-grey_darken-3"
                                        :class="{'headline': $vuetify.breakpoint.mdAndUp, 'title': $vuetify.breakpoint.smAndDown}"
                                        v-if="$i18n.locale == 'ru'"
                                    >
                                        Даже если компьютер сотрудника вышел из строя, данные не исчезнут и все так же будут доступны с любого
                                        подключенного к интернету компьютера.
                                    </span>
                                    <span
                                        class="font-grey_darken-3"
                                        :class="{'headline': $vuetify.breakpoint.mdAndUp, 'title': $vuetify.breakpoint.smAndDown}"
                                        v-else
                                    >
                                        Even if the employee's computer is out of order, the data will not disappear and will still be available from any computer connected to the Internet.
                                    </span>
                                </v-flex>
                            </v-card-text>
                        </v-card>
                    </v-layout>
                </v-flex>
                <v-flex
                    xs12
                    md6
                    brown lighten-5
                    class="half z-8 pa-2"
                    v-if="$vuetify.breakpoint.smAndDown"
                >
                    <v-card flat class="bg-transparent fill-height">
                        <v-layout row wrap align-center class="fill-height">
                            <v-img contain class="rounded" src="/img/start/09.webp" width="100%"></v-img>
                        </v-layout>
                    </v-card>
                </v-flex>

                <!-- Блок 10 -->
                <v-flex
                    xs12
                    md6
                    white
                    :class="{'sticky': $vuetify.breakpoint.mdAndUp, 'pa-5': $vuetify.breakpoint.smAndUp, 'half': $vuetify.breakpoint.smAndDown}"
                    class="z-9"
                >
                    <v-layout row wrap align-center fill-height>
                        <v-card flat class="bg-transparent">
                            <v-card-title>
                                <v-flex :class="{'center': $vuetify.breakpoint.smAndDown}">
                                    <span
                                        class="font-teal_darken-3"
                                        :class="{'display-2': $vuetify.breakpoint.lgAndUp, 'display-1': $vuetify.breakpoint.mdAndDown}"
                                        v-if="$i18n.locale == 'ru'"
                                    >Совместимость</span>
                                    <span
                                        class="font-teal_darken-3"
                                        :class="{'display-2': $vuetify.breakpoint.lgAndUp, 'display-1': $vuetify.breakpoint.mdAndDown}"
                                        v-else
                                    >Compatibility</span>
                                </v-flex>
                            </v-card-title>
                            <v-card-text>
                                <v-flex :class="{'center': $vuetify.breakpoint.smAndDown}">
                                    <span
                                        class="font-grey_darken-3"
                                        :class="{'headline': $vuetify.breakpoint.mdAndUp, 'title': $vuetify.breakpoint.smAndDown}"
                                        v-if="$i18n.locale == 'ru'"
                                    >
                                        Windows, macOS, Linux... Наше программное обеспечение работает везде где есть современный браузер.
                                    </span>
                                    <span
                                        class="font-grey_darken-3"
                                        :class="{'headline': $vuetify.breakpoint.mdAndUp, 'title': $vuetify.breakpoint.smAndDown}"
                                        v-else
                                    >
                                        Windows, macOS, Linux... Our software works wherever you have a modern browser.
                                    </span>
                                </v-flex>
                            </v-card-text>
                        </v-card>
                    </v-layout>
                </v-flex>
                <v-flex
                    xs12
                    md6
                    white
                    :class="{'sticky pa-5': $vuetify.breakpoint.mdAndUp, 'half pa-2': $vuetify.breakpoint.smAndDown}"
                    class="z-9"
                >
                    <v-card flat class="bg-transparent fill-height">
                        <v-layout row wrap align-center class="fill-height">
                            <v-img contain class="rounded" src="/img/start/10.webp" width="100%"></v-img>
                        </v-layout>
                    </v-card>
                </v-flex>
            </template>
        </v-layout>

        <v-fab-transition v-if="$vuetify.breakpoint.smAndDown">
            <v-btn
                v-show="scrolled"
                color="teal darken-1"
                @click="scrollToTop"
                dark
                fixed
                bottom
                right
                fab
                class="mb-4 z-top"
            >
                <v-icon>keyboard_arrow_up</v-icon>
            </v-btn>
        </v-fab-transition>
    </v-container>
</template>

<script>
    export default {
        name: "HomePage",

        data () {
            return {
                /*
                breadCrumbs: [
                    { text: "Домашняя страница", disabled: false }
                ],
                */
                scrolled: false,
                startImagesRu: [
                    { src: '/img/start/cards_ru/01.webp'},
                    { src: '/img/start/cards_ru/02.webp'},
                    { src: '/img/start/cards_ru/03.webp'},
                    { src: '/img/start/cards_ru/04.webp'},
                    { src: '/img/start/cards_ru/05.webp'},
                    { src: '/img/start/cards_ru/06.webp'},
                    { src: '/img/start/cards_ru/07.webp'},
                    { src: '/img/start/cards_ru/08.webp'},
                    { src: '/img/start/cards_ru/09.webp'},
                    { src: '/img/start/cards_ru/10.webp'},
                ],
                startImagesEn: [
                    { src: '/img/start/cards_en/01.webp'},
                    { src: '/img/start/cards_en/02.webp'},
                    { src: '/img/start/cards_en/03.webp'},
                    { src: '/img/start/cards_en/04.webp'},
                    { src: '/img/start/cards_en/05.webp'},
                    { src: '/img/start/cards_en/06.webp'},
                    { src: '/img/start/cards_en/07.webp'},
                    { src: '/img/start/cards_en/08.webp'},
                    { src: '/img/start/cards_en/09.webp'},
                    { src: '/img/start/cards_en/10.webp'},
                ]
            }
        },

        mounted () {
            this.applyLocale();
        },

        created () {
            window.addEventListener("scroll", this.onScroll);
        },

        destroyed () {
            window.removeEventListener("scroll", this.onScroll);
        },

        methods: {
            /**
             * Применение локали
             */
            applyLocale () {
                /*
                this.breadCrumbs = [
                    { text: this.$t("homePage"), disabled: false }
                ];
                */
            },

            /**
             * Отслеживание прокрутки экрана
             */
            onScroll () {
                this.scrolled = window.scrollY > 0;
            },

            /**
             * Прокрутка к началу экрана
             */
            scrollToTop () {
                window.scrollTo({
                    top:  0,
                    left: 0,
                    behavior: "smooth"
                });
            },

            /**
             * Вызов диалога авторизации
             */
            showAuth () {
                this.$emit("showAuth", true);
            },

            /**
             * Вызов диалога регистрации
             */
            showRegistration () {
                this.$emit("showRegistration", true);
            }
        }
    }
</script>

<style lang="sass" scoped>
    .home-card
        overflow-y: auto
        max-height: calc(100dvh - 84px)

    .bg-transparent
        background: transparent !important
    .title
        font-weight: 400
    .full-width
        max-width: 100%
    .font-light-blue_darken-3
        color: #0277bd
    .font-teal_darken-4
        color: #004d40
    .font-teal_darken-3
        color: #00695c
    .font-grey_darken-3
        color: #626262
    .font-white
        color: #fff
    .rounded
        border: dotted 1px #000
        border-radius: 5px !important

    .half
        min-height: calc(50vh - 50px)

    .sticky
        position: sticky
        top: 50px
        min-height: calc(100vh - 50px)
        &.half
            min-height: calc(50vh - 25px)

    .z-1
        z-index: 1
    .z-2
        z-index: 2
    .z-3
        z-index: 3
    .z-4
        z-index: 4
    .z-5
        z-index: 5
    .z-6
        z-index: 6
    .z-7
        z-index: 7
    .z-8
        z-index: 8
    .z-9
        z-index: 9
    .z-top
        z-index: 9999

    ul.no-marker
        list-style-type: none
        li
            margin-bottom: 15px
            i
                margin-left: -30px
</style>
